<template>
  <div class="jd-flow-nodes">
    <yo-steps minSize="65px">
      <yo-step>
        <yo-icon
          slot="icon"
          radius="50%"
          :src="flow.applyHeadImg"
          :centerText="flow.applyUserNickName | fmtIconName"
          bgColor="blue"
          size="44px"
          centerFontSize="14px"
        >
        </yo-icon>
        <div class="jd-flow-node">
          <div class="jd-flow-node-item">
            <div class="flow-title">
              <div class="title">申请人</div>
              <div class="des">{{ flow.applyUserNickName }}</div>
            </div>
            <div>{{ formatTime(flow.applyTime) }}</div>
          </div>
        </div>
      </yo-step>
      <yo-step
        v-for="(node, index) in flow.flow.norm.nodes"
        :key="`node_${index}`"
      >
        <yo-icon
          slot="icon"
          radius="50%"
          src="../../assets/images/work_shenpi_icon@3x.png"
          bgColor="blue"
          size="44px"
        >
        </yo-icon>
        <div class="jd-flow-node">
          <template v-if="node.state === 1">
            <div
              class="jd-flow-node-item arrow-up"
              :ref="`n_node_${index}`"
              @click="_clickView(`node_${index}`, `n_node_${index}`)"
            >
              <div class="flow-title">
                <div class="title">
                  <div>审批人</div>
                </div>
                <div class="des">
                  <div>
                    {{ node.info.proc.users.length }}人{{
                      node.info.proc.type | fmtNodeType
                    }}
                    <span
                      v-if="node.info.proc.optStatus === 4"
                      style="color: #888888"
                    >
                      ({{ node.info.proc.optStatus | fmtProcState }})
                    </span>
                    <span v-else style="color: #ff5900">
                      ({{ node.info.proc.optStatus | fmtProcState }})
                    </span>
                  </div>
                  <div class="arrow"></div>
                </div>
              </div>
              <div style="flex-shrink: 0">
                {{ formatTime(node.info.proc.lastTime) }}
              </div>
            </div>
            <div
              class="jd-flow-node-row-gap jd-flow-node-child"
              :ref="`node_${index}`"
              style="display: none"
            >
              <div
                v-for="(user, key) in node.info.proc.users"
                :key="`user_${key}`"
                class="jd-flow-node-row-gap"
              >
                <div class="jd-flow-node-item" style="align-items: center">
                  <yo-icon
                    slot="icon"
                    radius="50%"
                    :src="flow.flow.userMap[user.id].headImg"
                    bgColor="blue"
                    size="30px"
                    centerFontSize="11px"
                    :centerText="
                      flow.flow.userMap[user.id].userNickName | fmtIconName
                    "
                  >
                    <div slot="title" class="des">
                      <div class="yo_nowrap_1">
                        {{ flow.flow.userMap[user.id].userNickName }}
                      </div>
                      <div style="flex-shrink: 0">
                        <span
                          v-if="node.info.proc.optStatus === 4"
                          style="color: #888888"
                        >
                          ({{ node.info.proc.optStatus | fmtProcState }})
                        </span>
                        <span v-else style="color: #ff5900">
                          ({{ node.info.proc.optStatus | fmtProcState }}:
                          {{ user.opt.optTxt }})
                        </span>
                      </div>
                    </div>
                  </yo-icon>
                  <div style="flex-shrink: 0">
                    {{ formatTime(user.opt.optTime) }}
                  </div>
                </div>
                <!--<div v-if="user.opt.optTxt&&user.opt.optTxt!==''" style="padding-left: 0.8rem">-->
                <!--{{user.opt.optTxt}}-->
                <!--</div>-->
              </div>
            </div>
          </template>
          <template v-else>
            <div class="jd-flow-node-item">
              <div class="flow-title">
                <div class="title">审批人</div>
                <div class="des">申请内容与该审批条件不匹配，自动通过</div>
              </div>
            </div>
          </template>
        </div>
      </yo-step>
    </yo-steps>
  </div>
</template>

<script>
export default {
  name: 'FlowNodes',
  props: {
    flow: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  filters: {
    fmtNodeType(val) {
      switch (val) {
        case 1: {
          return '依次审批';
        }
        case 2: {
          return '与签';
        }
        case 3: {
          return '或签';
        }
      }
      return '';
    },
    fmtIconName(val) {
      if (val === null || val === undefined) {
        return '';
      }
      // return val.substring(0, 1);
      let start = val.length - 2;
      if (start < 0) start = 0;
      return val.substring(start, val.length);
    },
    fmtProcState(val) {
      switch (val) {
        case 1: {
          return "已撤销";
        }
        case 2: {
          return "审批中";
        }
        case 3: {
          return "已拒绝";
        }
        case 4: {
          return "已同意";
        }
        case 99: {
          return "已同意";
        }
        default: {
          return "审批中";
        }
      }
      return "";
    },
  },
  data() {
    return {
      up: true,
    };
  },
  methods: {
    _clickView(key, target) {
      if (this.$refs[key][0].style.display === '') {
        this.$refs[key][0].style.display = 'none';
        this.$refs[target][0].classList.toggle('arrow-up');
        this.$refs[target][0].classList.add('arrow-down');
      } else {
        this.$refs[key][0].style.display = '';
        this.$refs[target][0].classList.add('arrow-down');
        this.$refs[target][0].classList.toggle('arrow-up');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.jd-flow-nodes {
  padding: 10px 0 0 0;

  .jd-flow-node {
    padding: 0 0 0 10px;
    width: 100%;
    box-sizing: border-box;

    .jd-flow-node-child {
      > .jd-flow-node-item:not(:first-child) {
        margin-top: 10px;
      }
    }

    .jd-flow-node-row-gap {
      margin-top: 15px;
    }

    .jd-flow-node-item {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      color: #888888;
      flex-wrap: nowrap;

      .flow-title {
        flex-shrink: 0;
      }

      .title {
        color: #333333;
        font-weight: bold;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      .des {
        color: #888888;
        /*padding-bottom: 0.2rem;*/
        display: flex;
        justify-content: flex-start;
        align-items: center;

        > :not(:first-child) {
          margin-left: 50px;
        }
      }
    }

    .arrow-down {
      .arrow {
        background: url('@/assets/images/cur_arrow_close2@3x.png') no-repeat
          center center;
        background-size: contain;
        width: 12px;
        height: 12px;
      }
    }

    .arrow-up {
      .arrow {
        background: url('@/assets/images/cur_arrow_open2@3x.png') no-repeat
          center center;
        background-size: contain;
        width: 12px;
        height: 12px;
      }
    }

    .user {
      display: grid;
      grid-column: auto;
      grid-template-columns: repeat(auto-fill, minmax(30px, auto));
      grid-row-gap: 5px;
      /*grid-column-gap: 5px;*/
      justify-items: center;
      justify-content: flex-start;
      align-items: baseline;
      width: 100%;
    }
  }
}
</style>
